import { useTranslations } from 'next-intl';

export const PortalNodeClientsInfoMessage = ({ title, type }: { title: string; type: string }) => {
  const t = useTranslations('features');
  return (
    <div className="flex w-full px-4 py-2.5 bg-yellow-500/10">
      <p className="font-inter text-sm text-left">
        {t.rich('manage-members.granular_popup_description', {
          menuItemTitle: title,
          menuItemType: type,
          strong: (chunk) => <strong>{chunk}</strong>,
        })}
      </p>
    </div>
  );
};
